











































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Head from "components/header/head.vue";
import Nav from "components/navigation/nav.vue";
@Component({
  components: { Head, Nav }
})
export default class App extends Vue {
  // isShowScrollBar() {
  //   const { scrollHeight, clientHeight } = document.scrollingElement || {
  //     scrollHeight: 0,
  //     clientHeight: 0
  //   };
  //   return scrollHeight > clientHeight;
  // }
  // mounted() {
  //   const node = $('#footer');
  //   setInterval(() => {
  //     const isShow = this.isShowScrollBar();
  //     const itHas = node.hasClass('fixed-footer');
  //     isShow
  //       ? itHas && node.removeClass('fixed-footer')
  //       : itHas || node.addClass('fixed-footer');
  //   }, 800);
  // }
  navList = [
    {
      key: "installation",
      name: "Installation of Application",
      link: "Installation of Application"
    },
    {
      key: "navigation",
      name: "Define Navigation Tree",
      link: "Define Navigation Tree"
    },
    { key: "floorplan", name: "Build Floorplan", link: "Build Floorplan" },
    { key: "devices", name: "Add Devices", link: "Add Devices" },
    {
      key: "place",
      name: "Place Floormount Devices",
      link: "Place Floormount Devices"
    },
    { key: "discovery", name: "Auto Discovery", link: "Auto Discovery" },
    { key: "rack", name: "Rack Building", link: "Rack Building" },
    { key: "port", name: "Port Mapping", link: "Port Mapping" },
    { key: "device", name: "Device Settings", link: "Device Settings" },
    { key: "alarm", name: "Alarm Settings", link: "Alarm Settings" }
  ];
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app.vue